import React from "react";
import "./Contact.css";

export default function ContactPage() {
  return (
    <div className="contact-page">
      <div className="contact-inner">
        <h1 className="contact-title">Get in Touch</h1>
        <p className="contact-intro">
          Have a question, suggestion, or just want to say hi? We would love to
          hear from you.
        </p>

        <div className="contact-email-card">
          <a href="mailto:team@pacewerks.com">team@pacewerks.com</a>
        </div>
      </div>
    </div>
  );
}
